import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import CustomTable from "../../../components/custom-table/custom-table";
import NycbsStatusModal from "../../../components/modals/nycbsStatusModal/nycbsStatusModal";
import { PaginationKeys } from "../../../enums/nycbsPharmaOrder";
import { NycbsStatus } from "../../../enums/nycbsStatus";
import { fetchNycbsPharmaCompletedOrdersFromApi } from "../../../redux/slice/nycbsPharmaExternal/nycbsPharmaCompletedOrder";
import { appendNycbsPharmaOrdersFromApi } from "../../../redux/slice/nycbsPharmaExternal/nycbsPharmaOrder";
import { AppDispatch, RootState } from "../../../redux/store/store";
import { logDataToConsole } from "../../../utils/customLogger";
import { NycbsPharmaTableColumn } from "../../../utils/nycbsPharmaTableColumns";
import { generateTableDataForNycbsPharma } from "../../../utils/nycbsPharmaTableData";

const NycbsCompletedTable = () => {
  const { data, loading, pageData } = useSelector(
    (state: RootState) => state.nycbsPharmaCompletedOrders,
  );
  const { data: providersDetails } = useSelector(
    (state: RootState) => state.allProviders,
  );
  const [pharmaPaOrders, setPharmaPaOrders] = useState<any[]>([]);
  const [batchNumberRetreived, setBatchNumberRetreived] = useState<number[]>(
    [],
  );
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusData, setStatusData] = useState<{
    orderId: string;
    status: string;
  }>();
  const dispatch = useDispatch<AppDispatch>();

  const initialLimit = 40;

  const handleEndIndexOfTable = (endIndex: number) => {
    if (
      data &&
      pageData?.[PaginationKeys.TotalCount] !== null &&
      endIndex < (pageData?.[PaginationKeys.TotalCount] ?? 0) - 1 &&
      endIndex === data.length - 1
    ) {
      const nextBatchFetch = Math.round(data.length / initialLimit);
      if (nextBatchFetch > 0) {
        setBatchNumberRetreived((prevBatchNumberRetrieved) => {
          if (!prevBatchNumberRetrieved.includes(nextBatchFetch)) {
            return [...prevBatchNumberRetrieved, nextBatchFetch];
          }
          return prevBatchNumberRetrieved;
        });
      }
    }
  };

  const handleStatusForOrders = (data: { id: string; status: string }) => {
    const newData = {
      orderId: data.id,
      status: data.status,
    };
    setStatusData(newData);
    Number(data.status) !== NycbsStatus.UNASSIGNED && setShowStatusModal(true);
  };

  const handleStatusModalClose = () => {
    setShowStatusModal(false);
  };

  useEffect(() => {
    if (data) {
      logDataToConsole(
        "NycbsLayout",
        generateTableDataForNycbsPharma(data, providersDetails),
      );
      setPharmaPaOrders(
        generateTableDataForNycbsPharma(data, providersDetails),
      );
    }
  }, [data]);

  useEffect(() => {
    dispatch(appendNycbsPharmaOrdersFromApi(initialLimit));
  }, [JSON.stringify(batchNumberRetreived)]);

  useEffect(() => {
    showStatusModal && openModal("nycbs-status-modal");
  }, [showStatusModal]);
  return (
    <>
      <CustomTable
        tableHeaders={NycbsPharmaTableColumn}
        tableData={pharmaPaOrders}
        tableName={"nycbs-pharma-completed-orders"}
        isFetching={loading}
        count={pageData?.[PaginationKeys.TotalCount]}
        pagesPerView={5}
        itemsPerPage={10}
        hideSearchBar={false}
        endIndexOfTable={handleEndIndexOfTable}
        onStatusClick={(data) => handleStatusForOrders(data)}
        onRefreshButton={() =>
          dispatch(fetchNycbsPharmaCompletedOrdersFromApi(initialLimit))
        }
      />

      {showStatusModal && (
        <NycbsStatusModal
          onClose={handleStatusModalClose}
          orderId={statusData?.orderId ?? ""}
          status={
            Number(statusData?.status) in NycbsStatus
              ? Number(statusData?.status)
              : NycbsStatus.MARK_AS_COMPLETED
          }
        />
      )}
    </>
  );
};

export default NycbsCompletedTable;
